import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';


export interface TimePickerModel {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function* range(start: number, end: number) {
  for (let i = start; i <= end; i++) {
    yield i;
  }
}

@Component({
  //eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cron-time-picker',
  templateUrl: './cron-time-picker.component.html',
  styleUrls: ['./cron-time-picker.component.scss'],
  providers: [],
  standalone: false
})
export class CronTimePickerComponent implements OnChanges {

  @Input() public disabled;
  @Input() public use24HourTime = true;
  @Input() public hideHours = false;
  @Input() public hideMinutes = false;
  @Input() public hideSeconds = true;
  @Input() public minutesStartFrom = 0;

  get hours(): number[] {
    return this.use24HourTime ? [...range(0, 23)] : [...range(0, 12)];
  }

  public minutes = [...range(this.minutesStartFrom, 59)];
  public seconds = [...range(0, 59)];
  public hourTypes = ['AM', 'PM'];

  constructor(public parent: ControlContainer) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.minutesStartFrom) {
      this.minutes = [...range(this.minutesStartFrom, 59)];
    }
  }

  get parentGroup() {
    return this.parent.control as FormGroup;
  }
}